import AddIcon from '@mui/icons-material/Add';
import Button from '@mui/material/Button';
import { GridRowModes, GridRowModesModel, GridRowsProp, GridToolbarContainer } from '@mui/x-data-grid-pro';
import React from 'react';

interface EditToolbarProps {
	setRows: (newRows: (oldRows: GridRowsProp) => GridRowsProp) => void;
	setRowModesModel: (newModel: (oldModel: GridRowModesModel) => GridRowModesModel) => void;
	idIndex: number;
	loading: boolean;
}

export const DataGridAddBatchToolbar = ({ setRows, setRowModesModel, idIndex, loading }: EditToolbarProps) => (
	<GridToolbarContainer>
		{idIndex < 6 && (
			<Button
				color='primary'
				className='add-email-recipient-button'
				startIcon={<AddIcon />}
				disabled={loading}
				onClick={() => {
					setRows((oldRows) => [
						{
							id: idIndex,
							email: '',
							isNew: true,
						},
						...oldRows,
					]);
					setRowModesModel((oldModel) => ({
						...oldModel,
						[idIndex]: { mode: GridRowModes.Edit },
					}));
				}}
				data-cy='add-email-recipient-button'
			>
				Add Recipient
			</Button>
		)}
	</GridToolbarContainer>
);
